import { object, string } from 'yup';

const JobPostingCreateSchema = object().shape({
  start_date: string().required('Please enter your start date'),
  job_title: string().required('Enter a job title'),
  type: string(),
  location: object().required('Please enter location'),
  job_description: string(),
  rate: string().required('Please enter rate'),
});

export default JobPostingCreateSchema;
